import { Paragraph, Title } from "@/components/ui/typography";
import Image from "next/image";
import bg from "@/public/Graphics.png";
import { format } from "date-fns";

export default function Header({ data }) {
  return (
    <div className="sticky left-0 right-0 ml-[-50vw] mr-[-50vw] flex h-[220px] w-screen items-center justify-center overflow-hidden bg-midnightIndigo-100 md:h-[209px] lg:h-[342px]">
      <div className="absolute mr-auto w-full">
        <div className="mx-auto flex max-w-[1440px] flex-col items-center px-3 md:px-6 lg:px-11">
          <Title size="xxl" className="mb-4 text-center text-[32px] leading-[45px]">
            California Privacy Notice
          </Title>

          <Paragraph className="text-midnightIndigo-300">
           Last Updated {data?.updatedOn && format(new Date(data.updatedOn), "dd/MM/yyyy")}
          </Paragraph>
        </div>
      </div>

      <Image
        src={`${bg.src}`}
        className="absolute bottom-[0px] left-0 !h-full lg:w-full"
        width={1}
        height={1}
        layout="responsive"
      />
    </div>
  );
}
